import { NgModule,  CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
/** =================PIPES ============== */
import { TranslatePipe } from './pipes/translate.pipe';
/** ================= COMPONENTS ================ */
import { QuestionComponent } from './components/question/question.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TotalUiComponent } from './components/total-ui/total-ui.component'


import { FormsModule }   from '@angular/forms';




@NgModule({
  declarations: [
    TranslatePipe,
    QuestionComponent,
    TotalUiComponent,
    SpinnerComponent,

  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    TranslatePipe,
    QuestionComponent,
    TotalUiComponent,
    SpinnerComponent,
   
  ],

  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

  
})
export class SharedModule { }
